import React from 'react'
import './style.css'
import useIsMobile from '../../hooks/useIsMobile';

const AwardsAndPartners = () => {

    const isMobile = useIsMobile();

    const awardsIcons = [
        {
            icon: "/images/client-logo/google.png",
            height: 30,
            width: 130,
            mobileWidth: 100,
            text: "Google",
        },
        {
            icon: "/images/client-logo/aws.png",
            height: 30,
            width: 90,
            mobileWidth: 70,
            text: "Amazon Web Services",
        },
        {
            icon: "/images/client-logo/vercel.png",
            height: 100,
            width: 150,
            mobileWidth: 120,
            text: "Vercel",
        },
        {
            icon: "/images/client-logo/ISO-9001.svg",
            height: 40,
            width: 90,
            mobileWidth: 70,
            text: "ISO",
        },
        {
            icon: "/images/client-logo/27005.svg",
            height: 40,
            width: 90,
            mobileWidth: 70,
            text: "ISO",
        },
        {
            icon: "/images/client-logo/azure.svg",
            height: 30,
            width: 250,
            mobileWidth: 160,
            text: "Microsoft",
        },
        // {
        //     icon: "/images/client-logo/trust-pilot.png",
        //     height: 40,
        //     width: 140,
        //     text: "Trust Pilot",
        // },
        {
            icon: "/images/clutch-icons/payoneer-white.png",
            height: 40,
            width: 150,
            mobileWidth: 120,
            text: "Payoneer",
        },
        {
            icon: "/images/clutch-icons/clutch-white.png",
            height: 100,
            width: 100,
            mobileWidth: 80,
            text: "Clutch",
        },

        {
            icon: "/images/clutch-icons/cisco-white.png",
            height: 100,
            width: 130,
            mobileWidth: 80,
            text: "Clutch",
        },
        {
            icon: "/images/clutch-icons/gitlab-white.png",
            height: 100,
            width: 190,
            mobileWidth: 80,
            text: "Clutch",
        },
        {
            icon: "/images/clutch-icons/github-white.png",
            height: 100,
            width: 80,
            mobileWidth: 80,
            text: "Clutch",
        },
    ];

    return (
        <>
            <section className="awards-and-partners-section">
                <div className="container">
                    <div className="row text-center mb-4">
                        <div className="col-12">
                            <h2 className="section-title">Awards & <span>Partners</span></h2>
                            <p className="description-text-white">
                                Our awards & certifications highlight our commitment to excellence, innovation, & industry-leading standards.
                            </p>
                        </div>
                    </div>

                    <div className="row justify-content-center award-and-partners-tech-stack-scroller">
                        {/* col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6 mb-4 */}
                        {awardsIcons?.map((item, index) => {
                            return <div className="awards-and-icons-section-box" key={index}>
                                <div className="timeline-item text-center">
                                    <div className="timeline-icon">
                                        <img src={item?.icon} alt="Partners" width={isMobile && item?.mobileWidth ? item?.mobileWidth : item?.width} className="" />
                                    </div>
                                    <p className="timeline-text">{item?.text}</p>
                                </div>
                            </div>
                        })}
                    </div>

                    {/* <div className="row text-center mb-4 mt-3 mt-sm-4">
                        <div className="col-12">
                            <h2 className="section-title">Our Partnerships</h2>
                            <p className="description-text-white">
                                We collaborate with leading technology providers & organizations to deliver innovative solutions & drive success for our clients.
                            </p>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        {partnersIcons?.map((item, index) => {
                            return <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-6 mb-4" key={index}>
                                <div className="timeline-item text-center">
                                    <div className="timeline-icon">
                                        <img src={item?.icon} alt="Inc 5000 Logo" className="img-fluid" />
                                    </div>
                                    <p className="timeline-text">{item?.text}</p>
                                </div>
                            </div>
                        })}
                    </div> */}
                </div>
            </section>

        </>
    )
}

export default AwardsAndPartners